import { createContext, useContext, useState } from "react";
import useIsMobile from "../hooks/useIsMobile";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const mobile = useIsMobile();
  const [dukyOpen, setDukyOpen] = useState(false);
  const [audioOpen, setAudioOpen] = useState(false);
  const [movTab, setMovTab] = useState("todos");

  return (
    <UIContext.Provider value={{
      mobile,
      dukyOpen, setDukyOpen,
      audioOpen, setAudioOpen,
      movTab, setMovTab,
    }}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUI must be inside UIProvider");
  return ctx;
}
